import {
  DirectionDocTranslated,
  DocumentStatus,
  DocumentTypeTranslated,
  InvoiceBase,
} from '../../../types/Invoice';
import { PaymentStatusTranslated } from '../../../types/Payment';
import { formatPrice } from '../../../utils/functions/data.functions';
import ListButton, { ListButtonEntityType } from '../../listButton/ListButton';
import { TableColumn, ColDataType } from '../../table/DataTable.types';

export const columns = (onDocumentClick?: (item: InvoiceBase) => void): TableColumn[] => [
  {
    accessor: 'direction',
    name: 'page.invoice.col-direction',
    hideFilter: true,
    translateEnum: DirectionDocTranslated,
  },
  {
    accessor: 'type',
    name: 'page.invoice.col-type',
    translateEnum: DocumentTypeTranslated,
  },
  {
    accessor: 'documentNumber',
    name: 'page.invoice.col-doc-number',
    cellRenderer: (e) => {
      return (
        <span
          className={onDocumentClick ? `cursor-pointer underline` : ``}
          onClick={() => onDocumentClick && onDocumentClick(e.id)}
        >
          {e.documentNumber}
        </span>
      );
    },
    hideFilter: true,
  },
  {
    accessor: 'documentStatus',
    name: 'page.invoice.col-doc-status',
    className: `whitespace-nowrap`,
    cellRenderer(e) {
      return (
        <ListButton
          params={e.documentStatus as DocumentStatus}
          entityType={ListButtonEntityType.DOCUMENT_STATUS}
        />
      );
    },
  },
  {
    accessor: 'subscriberName',
    name: 'page.invoice.col-subscriber-name',
  },
  {
    accessor: 'issued',
    name: 'page.invoice.col-issued',
    hideFilter: true,
    dataType: ColDataType.DATE,
  },
  {
    accessor: 'dueDate',
    name: 'page.invoice.col-due-date',
    hideFilter: true,
    dataType: ColDataType.DATE,
  },
  {
    accessor: 'connectionAttributes',
    name: 'page.invoice.col-connections',
    hideFilter: true,
    cellRenderer(e) {
      return (
        <ListButton
          entityType={ListButtonEntityType.CONNECTION_ATTRIBUTES}
          params={e.connectionAttributes}
        />
      );
    },
  },
  {
    accessor: 'paymentState',
    name: 'page.invoice.col-payment-state',
    translateEnum: PaymentStatusTranslated,
    cellRenderer(e) {
      return (
        <ListButton params={e.paymentState} entityType={ListButtonEntityType.PAYMENT_STATUS} />
      );
    },
  },
  {
    accessor: 'totalWithVat',
    name: 'page.invoice.col-total-with-vat',
    className: `text-right ml-auto`,
    hideFilter: true,
    cellRenderer: (e) => (
      <span className="ml-auto bold font-bold">
        {formatPrice(e.totalWithVat)} {e.currency}
      </span>
    ),
  },
];
